import { useSelector } from "react-redux";
import DetailsCard from "../../../components/detailCard/DetailsCard";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";

import { setNotificationAction } from "../../../store/reducers/mmymSlice";
import PageTitle from "../../../components/pageTitle/PageTitle";
import ManageTenant from "./manageClient/ManageTenant";
import {
  getClientForEditAction,
  setEditClientAction,
} from "../../../store/reducers/adminClientsSlice";
import { Alert, Box, Button, Tab, Tabs } from "@mui/material";
import StatusBadge from "../../../components/common/StatusBadge";
import dayjs from "dayjs";
import { formatSortCode } from "../../../hooks/helper";
import FeatureTable from "../../../components/signup/FeatureTable";
import ManagePlanUpgrade from "./ManagePlanUpgrade";

const CompanyDetails = () => {
  const dispatch = useDispatch();

  const { editClientOriginalData, isClientEditSuccess } = useSelector(
    (state: any) => state.adminClients
  );
  const [open, setOpen] = useState(false);
  const [isShowPlanPopup, setIsShowPlanPopup] = useState(false);
  const { userProfile } = useSelector((state: any) => state?.user);
  const [value, setValue] = useState("0");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  useEffect(() => {
    dispatch(getClientForEditAction());
    return () => {
      dispatch(setNotificationAction({ message: [], severity: "info" }));
    };
  }, [dispatch]);

  useEffect(() => {
    if (isClientEditSuccess) {
      dispatch(setEditClientAction(false));
      dispatch(getClientForEditAction());
      setOpen(false);
      dispatch(setNotificationAction({ message: [], severity: "info" }));
    }
  }, [isClientEditSuccess]);

  const userData = [
    {
      id: "Client Name",
      value: `${
        editClientOriginalData?.client_name
          ? editClientOriginalData?.client_name
          : ""
      }`,
    },
    {
      id: "Company Name",
      value: `${
        editClientOriginalData?.company_name
          ? editClientOriginalData?.company_name
          : ""
      }`,
    },
    {
      id: "Phone Number",
      value: `${
        editClientOriginalData?.phone_number
          ? editClientOriginalData?.phone_number
          : ""
      }`,
    },
    {
      id: "Registered Addresss",
      value: `${
        editClientOriginalData?.address ? editClientOriginalData?.address : ""
      }`,
    },
    {
      id: "Registered Post Code",
      value: `${
        editClientOriginalData?.post_code
          ? editClientOriginalData?.post_code
          : ""
      }`,
    },
    {
      id: "Transport Post Code",
      value: `${
        editClientOriginalData?.transport_code
          ? editClientOriginalData?.transport_code
          : ""
      }`,
    },
    {
      id: "Corresponding Address",
      value: `${
        editClientOriginalData?.corresponding_address
          ? editClientOriginalData?.corresponding_address
          : ""
      }`,
    },
    {
      id: "Corresponding Post Code",
      value: `${
        editClientOriginalData?.corresponding_post_code
          ? editClientOriginalData?.corresponding_post_code
          : ""
      }`,
    },
    {
      id: "Company Strap Line",
      value: `${
        editClientOriginalData?.company_strap_line
          ? editClientOriginalData?.company_strap_line
          : ""
      }`,
    },
    {
      id: "VAT Registration Number",
      value: `${
        editClientOriginalData?.vat_reg_no
          ? editClientOriginalData?.vat_reg_no
          : ""
      }`,
    },
    {
      id: "VAT percentage",
      value: `${
        editClientOriginalData?.vat_percent
          ? editClientOriginalData?.vat_percent
          : ""
      }`,
    },
    {
      id: "Date Format",
      value: `${
        editClientOriginalData?.date_format
          ? editClientOriginalData?.date_format
          : ""
      }`,
    },
    {
      id: "Time Zone",
      value: `${
        editClientOriginalData?.timezone ? editClientOriginalData?.timezone : ""
      }`,
    },
    {
      id: "Company Registration No.",
      value: `${
        editClientOriginalData?.company_reg_no
          ? editClientOriginalData?.company_reg_no
          : ""
      }`,
    },
    {
      id: "Registration Date",
      value: `${
        editClientOriginalData?.registration_date
          ? dayjs(editClientOriginalData?.registration_date).format(
              userProfile?.dateFormat ? userProfile?.dateFormat : "DD/MM/YYYY"
            )
          : ""
      }`,
    },
    {
      id: "General Website",
      value: `${
        editClientOriginalData?.general_website
          ? editClientOriginalData?.general_website
          : ""
      }`,
    },
  ];

  const financialInformation = [
    {
      id: "Invoice Address",
      value: `${
        editClientOriginalData?.invoice_address
          ? editClientOriginalData?.invoice_address
          : ""
      }`,
    },
    {
      id: "Payment Terms",
      value: `${
        editClientOriginalData?.payment_terms
          ? editClientOriginalData?.payment_terms
          : ""
      }`,
    },
    {
      id: "Bank Sort Code",
      value: `${
        editClientOriginalData?.bank_sort_code
          ? formatSortCode(editClientOriginalData?.bank_sort_code)
          : ""
      }`,
    },
    {
      id: "Bank Account No.",
      value: `${
        editClientOriginalData?.bank_account_no
          ? editClientOriginalData?.bank_account_no
          : ""
      }`,
    },
    {
      id: "Account Holder Name",
      value: `${
        editClientOriginalData?.account_holder_name
          ? editClientOriginalData?.account_holder_name
          : ""
      }`,
    },
    {
      id: "IBAN",
      value: `${
        editClientOriginalData?.iban ? editClientOriginalData?.iban : ""
      }`,
    },
    {
      id: "Swift No.",
      value: `${
        editClientOriginalData?.swift_no ? editClientOriginalData?.swift_no : ""
      }`,
    },
    {
      id: "Bank Name",
      value: `${
        editClientOriginalData?.bank_name
          ? editClientOriginalData?.bank_name
          : ""
      }`,
    },
{
      id: "Invoice Due Days",
      value: `${
        editClientOriginalData?.invoice_due_days
          ? editClientOriginalData?.invoice_due_days
          : ""
      }`,
    },
    {
      id: "Deposit Payment %",
      value: `${
        editClientOriginalData?.deposit_payment_percent
          ? editClientOriginalData?.deposit_payment_percent
          : ""
      }`,
    },  
    {
      id: "Insurance/Liability %",
      value: `${
        editClientOriginalData?.extended_liability_percent
          ? editClientOriginalData?.extended_liability_percent
          : ""
      }`,
    },
    {
      id: "Insurance/Liability Premium Tax",
      value: `${
        editClientOriginalData?.extended_liability_tax
          ? editClientOriginalData?.extended_liability_tax
          : ""
      }`,
    },
    {
      id: "Insurance/Liability Fixed Rate",
      value: `${
        editClientOriginalData?.insurance_fixed_rate
          ? editClientOriginalData?.insurance_fixed_rate
          : ""
      }`,
    },
  ];

  const emailInformation = [
    {
      id: "Contact Email",
      value: `${
        editClientOriginalData?.email ? editClientOriginalData?.email : ""
      }`,
    },
    {
      id: "Customer Service",
      value: `${
        editClientOriginalData?.notification_email
          ? editClientOriginalData?.notification_email
          : ""
      }`,
    },
       {
      id: "Accounts Email",
      value: `${
        editClientOriginalData?.accounts_email
          ? editClientOriginalData?.accounts_email
          : ""
      }`,
    },
    // {
    //   id: "Email Password",
    //   value: `${editClientOriginalData?.email_password ? '********' : ""}`,
    // },
    {
      id: "Email Signature",
      value: `${
        editClientOriginalData?.email_signature
          ? editClientOriginalData?.email_signature
          : ""
      }`,
    },
  
    {
      id: "Email Desclaimer",
      value: `${
        editClientOriginalData?.email_disclaimer
          ? editClientOriginalData?.email_disclaimer
          : ""
      }`,
    },
  ];

  const subscriptionInformation = [
    {
      id: "Subscription",
      value: (
        <>
          {editClientOriginalData?.plan_name === null
            ? ""
            : editClientOriginalData?.plan_name}
          <Button
            size="small"
            variant="contained"
            sx={{ ml: 4, textTransform: "none", height: "26px" }}
            onClick={() => setIsShowPlanPopup(true)}
          >
           {editClientOriginalData?.plan_name ==='Professional' ? 'Downgrade' : 'Upgrade'}
          </Button>
        </>
      ),
    },
    {
      id: "Status",
      value: (
        <StatusBadge
          status={
            editClientOriginalData?.subscription_status === null
              ? ""
              : editClientOriginalData?.subscription_status
          }
        />
      ),
    },
    {
      id: "Term",
      value: `${
        editClientOriginalData?.subscription_start_date === null
          ? ""
          : dayjs(editClientOriginalData?.subscription_start_date).format(
              userProfile?.dateFormat ? userProfile?.dateFormat : "DD/MM/YYYY"
            )
      } - ${
        editClientOriginalData?.subscription_end_date === null
          ? ""
          : dayjs(editClientOriginalData?.subscription_end_date).format(
              userProfile?.dateFormat ?? "DD/MM/YYYY"
            )
      }`,
    },
    {
      id: "Frequency",
      value: `${
        editClientOriginalData?.subscription_duration === null
          ? ""
          : editClientOriginalData?.subscription_duration === "5D"
          ? "5 Days Trial"
          : editClientOriginalData?.subscription_duration === "3M"
          ? "3 Months"
          : editClientOriginalData?.subscription_duration === "6M"
          ? "6 Months"
          : editClientOriginalData?.subscription_duration === "12M"
          ? "12 Months"
          : editClientOriginalData?.subscription_duration
      }`,
    },
    {
      id: "Renews On",
      value: `${
        editClientOriginalData?.subscription_end_date === null
          ? ""
          : dayjs(editClientOriginalData?.subscription_end_date)
              .add(1, "day")
              .format(
                userProfile?.dateFormat ? userProfile?.dateFormat : "DD/MM/YYYY"
              )
      } `,
    },
    {
      id: "Subscription Cost",
      value: `${
        editClientOriginalData?.cost === null
          ? ""
          : editClientOriginalData?.cost
      }`,
    },
    {
      id: "Discount",
      value: `${
        editClientOriginalData?.subscription_discount === null
          ? ""
          : editClientOriginalData?.subscription_discount
      }`,
    },
    {
      id: "Amount Payable",
      value: `${
        editClientOriginalData?.subscription_paid_amount === null
          ? ""
          : editClientOriginalData?.subscription_paid_amount
      }`,
    },
    {
      id: "Payment Method",
      value: `${
        editClientOriginalData?.subscription_payment_method === null
          ? ""
          : editClientOriginalData?.subscription_payment_method
      }`,
    },
  ];

  const newSubscriptionChange = [
    {
      id: "Subscription Changes",
      value: (
        <>
          {editClientOriginalData?.sc_note === null
            ? ""
            : editClientOriginalData?.sc_note}
        </>
      ),
    },
    {
      id: "Subscription Changes Status",
      value: (
        <StatusBadge
          status={
            editClientOriginalData?.sc_status === null
              ? ""
              : editClientOriginalData?.sc_status
          }
        />
      ),
    },
    {
      id: "Subscription Changes Mode",
      value: (
        <>
          {editClientOriginalData?.sc_mode
            ? editClientOriginalData.sc_mode.charAt(0).toUpperCase() +
              editClientOriginalData.sc_mode.slice(1).toLowerCase()
            : ""}
        </>
      ),
    },

    {
      id: "New Subscription Activation Date",
      value: `${
        editClientOriginalData?.sc_effective_at === null
          ? ""
          : dayjs(editClientOriginalData?.sc_effective_at).format(
              userProfile?.dateFormat ? userProfile?.dateFormat : "DD/MM/YYYY"
            )
      }`,
    },
  ];

  // Merge subscriptionInformation and newSubscriptionChange if sc_mode exists
  const mergedSubscriptionInformation = [
    ...subscriptionInformation,
    ...(editClientOriginalData?.sc_mode ? newSubscriptionChange : []),
  ];

  const handleClose = () => {
    setOpen(false);
  };

  const handleEditClient = () => {
    setOpen(true);
    dispatch(getClientForEditAction());
  };

  return (
    <>
      {!editClientOriginalData?.transport_code && (
        <Alert severity="warning" style={{ marginBottom: "10px" }}>
          You'll need to add the details in order to proceed.
        </Alert>
      )}
      {isShowPlanPopup && (
        <ManagePlanUpgrade
          alertModalShow={isShowPlanPopup}
          setAlertModelShow={setIsShowPlanPopup}
          onHide={() => setIsShowPlanPopup(false)}
        />
      )}
      {open && (
        <ManageTenant
          selectClient={""}
          open={open}
          onHide={handleClose}
          title="Edit Client"
          action={"edit"}
        />
      )}

      <PageTitle
        title="Company Details"
        button={
          (userProfile?.roles?.includes("Owner") ||
            userProfile?.roles?.includes("TENANT")) &&
          "Edit"
        }
        onClick={handleEditClient}
      />
      <Tabs
        // centered
        value={value}
        onChange={handleChange}
        textColor="secondary"
        indicatorColor="secondary"
        aria-label="secondary tabs example"
        variant="standard"
        sx={{
          background: "#fff",
          fontSize: "14px",
          fontWeight: 600,
          marginBottom: "16px",
        }}
      >
        <Tab value="0" label="Company Info" />
        {/* <Tab value="1" label="Financial Info" /> */}
        <Tab value="2" label="Email Settings" />
        <Tab value="3" label="Subscription" />
      </Tabs>
      {value === "0" && <DetailsCard rows={userData} />}
      {value === "1" && <DetailsCard rows={financialInformation} />}
      {value === "2" && <DetailsCard rows={emailInformation} />}
      {value === "3" && <DetailsCard rows={mergedSubscriptionInformation} />}
    </>
  );
};
export default CompanyDetails;
